import { useQuery } from '@tanstack/react-query';
import { PROVIDER_TYPE_ENUM } from 'modules/inventory/provider/common/constants/provider.types';
import { ProviderFieldService } from '../services';
import { IProviderField } from '../interfaces/IProviderField';

export const PROVIDER_FIELDS_BY_TYPE_KEY = 'PROVIDER_FIELDS_BY_TYPE';

export const useProviderFieldsByType = (providerType: PROVIDER_TYPE_ENUM) => {
  return useQuery<IProviderField[]>({
    queryKey: [PROVIDER_FIELDS_BY_TYPE_KEY, providerType],
    queryFn: () => ProviderFieldService.getByType(providerType),
    enabled: !!providerType,
    staleTime: 1000 * 60 * 5,
  });
};
